import { render, staticRenderFns } from "./OrderLayoutReqResEditDialog.vue?vue&type=template&id=057abb8a"
import script from "./OrderLayoutReqResEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderLayoutReqResEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports